// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ea4aa01a","455":"c8c6ddd5","977":"8efead73"}[chunkId] + ".chunk.js";
};